<template>
  <Transition name="slide-fadeUp" appear>
    <div v-if="visible" class="modal-center">
      <div class="generate-modal-content">
        <div class="generate-options">
          <button class="create-manual" @click="handleManualClick">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="add-icon">
                <path d="M6 12H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 18V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

            </div>
            <h4>{{$t('create_micro_learning')}}</h4>
          </button>

          <button class="create-gen-ai" @click="handleGenAIClick">
            <span></span>
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="lightning-icon">
                <path d="M17.91 10.7199H14.82V3.5199C14.82 1.8399 13.91 1.4999 12.8 2.7599L12 3.6699L5.23001 11.3699C4.30001 12.4199 4.69001 13.2799 6.09001 13.2799H9.18001V20.4799C9.18001 22.1599 10.09 22.4999 11.2 21.2399L12 20.3299L18.77 12.6299C19.7 11.5799 19.31 10.7199 17.91 10.7199Z" fill="currentColor"/>
              </svg>
            </div>
            <h4>{{$t('create_nano_course')}}</h4>
          </button>

          <button class="create-manual" @click="handleTransformClick">
            <span></span>
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="add-icon">
                <path opacity="0.4" d="M11 16.15V18.85C11 21.1 10.1 22 7.85 22H5.15C2.9 22 2 21.1 2 18.85V16.15C2 13.9 2.9 13 5.15 13H7.85C10.1 13 11 13.9 11 16.15Z" fill="currentColor"/>
                <path opacity="0.4" d="M17.5 11C19.9853 11 22 8.98528 22 6.5C22 4.01472 19.9853 2 17.5 2C15.0147 2 13 4.01472 13 6.5C13 8.98528 15.0147 11 17.5 11Z" fill="currentColor"/>
                <path d="M14.78 22C14.51 22 14.26 21.85 14.13 21.62C14 21.38 14 21.1 14.14 20.86L15.11 19.24C15.32 18.88 15.78 18.77 16.14 18.98C16.5 19.19 16.61 19.65 16.4 20.01L16.22 20.31C18.69 19.67 20.51 17.43 20.51 14.77C20.51 14.36 20.85 14.02 21.26 14.02C21.67 14.02 22 14.36 22 14.78C22 18.76 18.76 22 14.78 22Z" fill="currentColor"/>
                <path d="M2.75 9.97C2.34 9.97 2 9.64 2 9.22C2 5.24 5.24 2 9.22 2C9.5 2 9.74 2.15 9.88 2.38C10.01 2.62 10.01 2.9 9.87 3.14L8.9 4.75C8.68 5.11 8.22 5.23 7.87 5.01C7.51 4.8 7.4 4.34 7.61 3.98L7.79 3.68C5.33 4.32 3.5 6.56 3.5 9.22C3.5 9.64 3.16 9.97 2.75 9.97Z" fill="currentColor"/>
              </svg>
            </div>
            <h4>{{$t('transform_document_into_program')}}</h4>
          </button>
        </div>

        <button class="cancel-button" @click="onHide">
          <img src="@/assets/images/cross.svg" alt="Cancel" />
          <span>{{$t('cancel_button')}}</span>
        </button>

        <!--
        <div class="modal-transform-options">
          <div class="upload-file" :class="{'active': dragActive, 'error': hasError.length > 0}" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive" @drop.prevent="onDrop" @click="onUploadClick">
            <input type="file" id="transform-file" style="display: none" @change="onFileInputChange" accept=".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation">

            <svg v-if="!transformLoading" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="upload-icon">
              <path d="M9 17V11L7 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 11L11 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <h5 v-if="!transformLoading">
              {{$t('transform_document_into_program')}}
            </h5>
            <span v-if="!transformLoading">
              {{$t('drag_and_drop_pdf')}}
            </span>

            <VueSpinnerIos v-if="transformLoading" size="24"/>
          </div>
          <span class="upload-error-span" v-if="hasError.length > 0">{{hasError}}</span>

        </div>
        -->
      </div>
    </div>
  </Transition>
</template>

<script>
import {VueSpinnerIos} from "vue3-spinners";
import aiService from "@/service/aiService";
import {handleErrorResponse} from "@/utils/utils";

export default {
  components: {VueSpinnerIos},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    onAction: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {

    }
  },
  methods: {
    handleManualClick() {
      this.onAction('manual');
    },
    handleGenAIClick() {
      this.onAction('genAI');
    },
    handleTransformClick() {
      this.onAction('transform');
    },
  },

};
</script>

<style scoped>
.generate-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.generate-options {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  flex: 1;
}

h5 {
  font-family: euclid_medium, sans-serif;
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.create-manual {
  border: none;
  outline: none;
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  flex: 1;
  height: 220px;
  width: 220px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
}

.create-manual:hover {
  background-color: #F2F4F7;
  transform: translateY(-3px);
}

.create-gen-ai img, .create-manual img{
  width: 32px;
  height: 32px;
}

.create-gen-ai h4, .create-manual h4 {
  font-family: euclid_semi_bold, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin-top: 15px;
}

.create-gen-ai h4 {
  font-size: 18px;
}

.create-gen-ai {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  flex: 1;
  height: 250px;
  min-width: 250px;
  position: relative;
  color: #333;
  font-weight: 500;
  border: none;
  outline: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
  overflow: hidden;
  z-index: 1;
}

/* Top orange gradient */
.create-gen-ai::before {
  content: "";
  position: absolute;
  top: -35%;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  height: 150px;
  background: radial-gradient(circle, #F09461 20%, rgba(240, 148, 97, 0) 50%);
  filter: blur(15px);
  opacity: 0.3;
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: -1;
}

/* Left green gradient */
.create-gen-ai::after {
  content: "";
  position: absolute;
  bottom: -20%;
  left: -20%;
  width: 150px;
  height: 200px;
  background: radial-gradient(circle, #3DA33E 20%, rgba(61, 163, 62, 0) 70%);
  filter: blur(15px);
  opacity: 0.3;
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: -1;
}

/* Right blue gradient - using an additional pseudo-element */
.create-gen-ai > span {
  content: "";
  position: absolute;
  bottom: -20%;
  right: -20%;
  width: 150px;
  height: 200px;
  background: radial-gradient(circle, #4968F8 20%, rgba(73, 104, 248, 0) 65%);
  filter: blur(15px);
  opacity: 0.3;
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: -1;
  pointer-events: none;
}

/* Empty span for the blue gradient */
.create-gen-ai::before span {
  display: none;
}

/* Hover effects */
.create-gen-ai:hover::before {
  transform: translate(-50%, 30%) scale(1.6);
  opacity: 0.85;
  filter: blur(20px);
}

.create-gen-ai:hover::after {
  transform: translate(40%, 20%) scale(1.6);
  opacity: 0.85;
  filter: blur(20px);
}

.create-gen-ai:hover > span {
  transform: translate(-40%, 20%) scale(1.6);
  opacity: 0.85;
  filter: blur(20px);
}

.create-gen-ai:hover {
  transform: translateY(-3px);
  background-color: #fff;
}

.create-gen-ai:hover h4 {
  color: #000;
}

.icon-wrapper {
  display: inline-flex;
  cursor: pointer;
  background-color: #d0e0fb;
  padding: 10px;
  border-radius: 50%;
}

.lightning-icon {
  color: #667085;
  transition: color 0.3s ease;
  width: 36px;
  height: 36px;
}

.add-icon {
  color: #667085;
  transition: color 0.3s ease;
  width: 24px;
  height: 24px;
}

.create-gen-ai:hover .lightning-icon {
  color: #000;
}

.create-manual:hover .add-icon {
  color: #000;
}

.create-manual:hover h4 {
  color: #000;
}

.cancel-button {
  background: #fff;
  border: none;
  border-radius: 24px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.4s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cancel-button:hover {
  background: #F2F4F7;
}

.cancel-button img {
  width: 12px;
  height: 12px;
}

.cancel-button span {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}


</style>
